// HerosFormation.jsx
import React, { useState, useEffect } from 'react';

const HerosFormation = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);
  const fullText = 'Bisenter Formations';

  useEffect(() => {
    if (index < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + fullText[index]);
        setIndex((prev) => prev + 1);
      }, 150);
      return () => clearTimeout(timeout);
    }
  }, [index, fullText]);

  return (
    <>
      <style>{`
        .heros-formation {
          position: relative;
          width: 100%;
          max-width:100%;
          height: 50vh;
          background-image: url('/img/forms.jpg');
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-family: 'Arial', sans-serif;
          overflow: hidden;
        }

        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1;
        }

        .contenu {
          position: relative;
          z-index: 2;
          text-align: center;
          padding: 0 20px;
        }

        .titre-anime {
          font-size: 4rem;
          font-weight: bold;
          letter-spacing: 4px;
          margin-bottom: 0.5rem;
          text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
        }

        .curseur {
          display: inline-block;
          animation: clignotement 0.8s step-end infinite;
          color: #ffcc00;
          font-weight: 300;
        }

        @keyframes clignotement {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }

        .sous-titre {
          font-size: 1.5rem;
          opacity: 0.8;
          text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        }

        @media (max-width: 768px) {
          .titre-anime {
            font-size: 2.5rem;
          }
          .sous-titre {
            font-size: 1.2rem; 
          }
        }
      `}</style>

      <section className="heros-formation">
        <div className="overlay"></div>
        <div className="contenu">
          <h1 className="titre-anime">
            {displayedText}
            <span className="curseur">|</span>
          </h1>
          <p className="sous-titre">Maîtrisez votre avenir avec nos formations</p>
        </div>
      </section>
    </>
  );
};

export default HerosFormation;